import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import Romeo from './components/Romeo';
import Juliet from './components/Juliet';
import Matchmaker from './components/Matchmaker';
import MatchmakerOverview from './components/MatchmakerOverview';
import SearchCandidates from './components/SearchCandidates';
import HealthCheck from './components/HealthCheck';
import Login from './components/Login';
import TeamAdmin from './components/TeamAdmin';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import AcceptInvite from './components/AcceptInvite';
import { isAuthenticated } from './services/api';
import { CustomSearchProvider } from './contexts/CustomSearchContext';

// Protected Route Component
function ProtectedRoute({ children }) {
  const location = useLocation();
  
  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return children;
}

// Public Route Component (redirects to dashboard if authenticated)
function PublicRoute({ children }) {
  if (isAuthenticated()) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

function AppLayout({ children }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleToggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <>
      <Sidebar isOpen={isSidebarOpen} onClose={handleCloseSidebar} />
      <div className="app-shell">
        <header className="mobile-topbar">
          <div className="mobile-topbar-title">
            <span className="mobile-topbar-logo">LS</span>
            <span className="mobile-topbar-text">LegalSoft</span>
          </div>
          <button
            className={`hamburger-button ${isSidebarOpen ? 'is-open' : ''}`}
            onClick={handleToggleSidebar}
            aria-label={isSidebarOpen ? 'Close navigation' : 'Open navigation'}
          >
            <span />
            <span />
            <span />
          </button>
        </header>
        <div className="main-content">
          {children}
        </div>
      </div>
    </>
  );
}

function AppContent() {
  return (
    <Routes>
        <Route path="/login" element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        } />
        <Route path="/forgot-password" element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        } />
        <Route path="/reset-password" element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        } />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route path="/" element={
          <ProtectedRoute>
            <AppLayout>
              <Dashboard />
            </AppLayout>
          </ProtectedRoute>
        } />
        <Route path="/romeo" element={
          <ProtectedRoute>
            <AppLayout>
              <Romeo />
            </AppLayout>
          </ProtectedRoute>
        } />
        <Route path="/juliet" element={
          <ProtectedRoute>
            <AppLayout>
              <Juliet />
            </AppLayout>
          </ProtectedRoute>
        } />
        <Route path="/matchmaker" element={
          <ProtectedRoute>
            <AppLayout>
              <MatchmakerOverview />
            </AppLayout>
          </ProtectedRoute>
        } />
        <Route path="/matchmaker/:jobId" element={
          <ProtectedRoute>
            <AppLayout>
              <Matchmaker />
            </AppLayout>
          </ProtectedRoute>
        } />
        <Route path="/search" element={
          <ProtectedRoute>
            <AppLayout>
              <SearchCandidates />
            </AppLayout>
          </ProtectedRoute>
        } />

        <Route path="/admin/team" element={
          <ProtectedRoute>
            <AppLayout>
              <TeamAdmin />
            </AppLayout>
          </ProtectedRoute>
        } />
        <Route path="/health" element={
          <ProtectedRoute>
            <AppLayout>
              <HealthCheck />
            </AppLayout>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
  );
}

function App() {
  return (
    <Router>
      <CustomSearchProvider>
        <div className="App">
          <AppContent />
        </div>
      </CustomSearchProvider>
    </Router>
  );
}

export default App;
